import {Autocomplete, Drawer, Stack, TextField} from "@mui/material";
import React from "react";
import {addProduct, Product, proServ} from "../../../firebase/index.js";
import APXActionButtons from "../../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../../reusables/js/APXBottomSheetLayoutUtils.js";


export type AddNewProductBSLProps = { industryKey: string, existingProducts: Product[] } & BSLProps;


export default function AddNewProductBSL({uid, onClose, industryKey, existingProducts}: AddNewProductBSLProps) {
	  
	  const {isOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const [disablePositiveByDefault, setDisablePositiveByDefault] = React.useState(true);
	  
	  const [productName, setProductName] = React.useState("");
	  const [productVariantName, setProductVariantName] = React.useState("");
	  
	  React.useEffect(() => {
			 setDisablePositiveByDefault(/*FALSY->*/ !!!productName.trim() || /*FALSY->*/ !!!productVariantName.trim() ||
						existingProducts.some((value: Product) => value.productName === productName.trim() && value.productVariantName === productVariantName.trim()));
	  }, [productName, productVariantName]);
	  
	  const handleCancel = () => {
			 setProductName("");
			 setProductVariantName("");
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 const product = new Product(productName.trim(), productVariantName.trim());
			 addProduct(uid, industryKey, product.getKey(), product);
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
									 <Autocomplete options={(existingProducts: Product[]).map((value) => value.productName).filter((value, index, self) => self.indexOf(value) === index)}
														fullWidth
														freeSolo
														clearOnEscape={false}
														disableClearable={true}
														renderInput={
															  (params) =>
																		 <TextField {...params} label={`${proServ} Name`} variant="outlined" fullWidth required
																						inputProps={{...params.inputProps, readOnly: false}}
																		 />
														}
														value={productName}
														onInputChange={(e, newValue) => setProductName(newValue)}
									 />
									 <Autocomplete options={(existingProducts: Product[]).map((value) => value.productVariantName).filter((value, index, self) => self.indexOf(value) === index)}
														fullWidth
														freeSolo
														clearOnEscape={false}
														disableClearable={true}
														renderInput={
															  (params) =>
																		 <TextField {...params} label={`${proServ} Variant`} variant="outlined" fullWidth required
																						inputProps={{...params.inputProps, readOnly: false}}
																		 />
														}
														value={productVariantName}
														onInputChange={(e, newValue) => setProductVariantName(newValue)}
									 />
							  </Stack>
							  
							  
							  <APXActionButtons onCancel={handleCancel}
													  onAdd={handleAdd}
													  disablePositiveByDefault={disablePositiveByDefault}
							  />
						</Stack>
				 </Drawer>
	  );
}
